var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Testimonials',{attrs:{"title":_vm.title,"subtitle":_vm.subtitle,"testimonials":_vm.testimonials,"alternative-layout":_vm.alternativeLayout}})
}
var staticRenderFns = []

export { render, staticRenderFns }